var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#6358DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 33.3125C43.9594 33.3125 39.0625 38.2094 39.0625 44.25C39.0625 50.2906 43.9594 55.1875 50 55.1875C56.0406 55.1875 60.9375 50.2906 60.9375 44.25C60.9375 38.2094 56.0406 33.3125 50 33.3125ZM35.9375 44.25C35.9375 36.4835 42.2335 30.1875 50 30.1875C57.7665 30.1875 64.0625 36.4835 64.0625 44.25C64.0625 52.0165 57.7665 58.3125 50 58.3125C42.2335 58.3125 35.9375 52.0165 35.9375 44.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 58.3105C46.4341 58.3105 42.931 59.2493 39.843 61.0324C36.7549 62.8155 34.1906 65.3801 32.4079 68.4684C31.9765 69.2158 31.021 69.4719 30.2736 69.0405C29.5262 68.6091 29.2701 67.6535 29.7015 66.9062C31.7584 63.3427 34.7172 60.3835 38.2803 58.3261C41.8435 56.2687 45.8855 55.1855 50 55.1855C54.1145 55.1855 58.1565 56.2687 61.7197 58.3261C65.2829 60.3835 68.2416 63.3427 70.2986 66.9062C70.73 67.6535 70.4738 68.6091 69.7265 69.0405C68.9791 69.4719 68.0235 69.2158 67.5921 68.4684C65.8094 65.3801 63.2452 62.8155 60.1571 61.0324C57.069 59.2493 53.5659 58.3105 50 58.3105Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.b205d9cf95cfbc836b3f2affe23996d0.svg";
export { ForwardRef as ReactComponent };